import actionTypes from "../../common/actionTypes";
import { DATABASE_STATUTES } from "../../common/constants";
import { initialState } from "../../common/V2/shopConstants";

export const shopReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SHOP:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
      };

    case actionTypes.FETCH_SHOP_SUCCESS: {
      const shop = action.payload.shop;
      return {
        ...state,
        shop: {
          createdAt: shop.createdAt,
          deepLink: shop.deepLink || "",
          email: shop.email || "",
          status: DATABASE_STATUTES.LOADED,
          hasCustomScript: shop.hasCustomScript || false,
          hasReviewed: shop.hasReviewed || false,
          hasProducts: shop.hasProducts || false,
          hasCustomerExperiences: shop.hasCustomerExperiences || false,
          id: shop.id || null,
          isAtRiskOfBadReview: shop.isAtRiskOfBadReview || false,
          isEnabled: shop.isEnabled || false,
          isInstalled: shop.isInstalled || false,
          isOnboarded: shop.isOnboarded || false,
          locale: shop.locale || "en",
          shopifyPlan: shop.shopifyPlan || null,
          timezone: shop.timezone || "UTC",
          name: shop.name || null,
          phone: shop.phone || null,
          scriptVersion: shop.scriptVersion || "0.0",
          shopifyDomain: shop.shopifyDomain || null,
          updatedAt: shop.updatedAt || null,
          accessToken: shop.accessToken || null,
          deletedAt: shop.deletedAt || null,
          customDomain: shop.customDomain,
          subscription: shop.subscription,
          settings: {
            selectors: shop.settings?.selectors || initialState.settings.selectors,
          },
        },
        status: DATABASE_STATUTES.LOADED,
      };
    }

    case actionTypes.FETCH_SHOP_FAILURE:
      return {
        ...state,
        error: action.error,
        status: DATABASE_STATUTES.LOADED,
        shop: { ...initialState },
      };

    case actionTypes.FETCH_CUSTOM_DOMAIN:
      return {
        ...state,
        shop: { ...state.shop, customDomain: { ...state.shop.customDomain } },
      };

    case actionTypes.FETCH_CUSTOM_DOMAIN_FAILURE:
      return {
        ...state,
        shop: { ...state.shop, customDomain: { ...state.shop.customDomain, error: action.error } },
      };

    case actionTypes.FETCH_CUSTOM_DOMAIN_SUCCESS:
      return {
        ...state,
        shop: { ...state.shop, customDomain: { ...state.shop.customDomain, ...action.payload } },
      };

    case actionTypes.UPDATE_CUSTOM_DOMAIN:
      return {
        ...state,
        shop: {
          ...state.shop,
          customDomain: {
            ...state.shop.customDomain,
            ...action.payload,
          },
        },
      };

    case actionTypes.UPDATE_THEME_EXTENSION_STATUS:
      return {
        ...state,
        shop: {
          ...state.shop,
          isEnabled: action.payload.isEnabled,
        },
      };

    case actionTypes.UPDATE_SHOP_SELECTORS:
      return {
        ...state,
        shop: {
          ...state.shop,
          settings: {
            ...state.shop.settings,
            selectors: action.payload,
          },
        },
      };

    case actionTypes.UPDATE_SHOP:
      return {
        ...state,
        shop: {
          ...state.shop,
          ...action.payload,
        },
      };

    case actionTypes.STORE_SUBSCRIBE_CONFIRMATION_URL:
      return {
        ...state,
        subscribeConfirmUrl: action.payload,
      };

    case actionTypes.REMOVE_SUBSCRIBE_CONFIRMATION_URL:
      return {
        ...state,
        subscribeConfirmUrl: "",
      };

    default:
      return state;
  }
};
